import React from 'react';

type StepId = 'download' | 'name' | 'address' | 'typeCheckbox' | 'nontrouve' | 'residual' | 'coprosPerdues' | 'summary' | 'syndicFeedback';

interface StepDef {
  id: StepId;
  label: string;
  description?: string;
  optional?: boolean;
}

interface StepNavigationProps {
  steps: StepDef[];
  activeStep: StepId;
  onStepSelect: (step: StepId) => void;
  onPrev: () => void;
  onNext: () => void;
  isSaving: boolean;
}

const StepNavigation: React.FC<StepNavigationProps> = ({
  steps,
  activeStep,
  onStepSelect,
  onPrev,
  onNext,
  isSaving,
}) => {
  const currentIndex = steps.findIndex((s) => s.id === activeStep);
  let numberedIndex = 0;
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex flex-wrap items-center gap-3">
        {steps.map((step, index) => {
          const isActive = step.id === activeStep;
          const isDone = index < currentIndex;
          const stepNumber = step.optional ? null : ++numberedIndex;
          return (
            <button
              key={step.id}
              onClick={() => onStepSelect(step.id)}
              className={`flex items-center gap-2 rounded border px-3 py-2 transition-colors ${
                isActive
                  ? step.optional
                    ? 'border-amber-400 bg-amber-50 text-amber-700'
                    : 'border-rgpd-blue-dark bg-blue-50 text-rgpd-blue-dark'
                  : isDone
                    ? 'border-green-200 bg-green-50 text-green-700'
                    : step.optional
                      ? 'border-dashed border-gray-300 bg-gray-50 text-gray-500 hover:border-amber-300 hover:text-amber-600'
                      : 'border-gray-200 bg-gray-50 text-gray-700 hover:border-gray-300'
              }`}
              disabled={isSaving}
            >
              <span className={`text-xs font-semibold ${step.optional ? 'italic' : ''}`}>
                {stepNumber ?? 'Opt.'}
              </span>
              <div className="text-left">
                <p className="text-sm font-semibold">{step.label}</p>
                {step.description && <p className="text-[11px] text-gray-500">{step.description}</p>}
              </div>
            </button>
          );
        })}
      </div>

      <div className="mt-4 flex justify-between">
        <button
          onClick={onPrev}
          disabled={currentIndex === 0 || isSaving}
          className="rounded border border-gray-200 bg-gray-100 px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Étape précédente
        </button>
        <button
          onClick={onNext}
          disabled={currentIndex === steps.length - 1 || isSaving}
          className="rounded bg-rgpd-blue-dark px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-rgpd-blue disabled:cursor-not-allowed disabled:opacity-50"
        >
          Étape suivante
        </button>
      </div>
    </div>
  );
};

export type { StepId };
export default StepNavigation;
